// extracted by mini-css-extract-plugin
export default {"headerBar":"NewIntegratedRound_headerBar__P5QJc"};